import Http from 'core/http/HttpService';

export default class BaseService {
  get(...args) {
    return Http.get(...args);
  }

  post(...args) {
    return Http.post(...args);
  }

  put(...args) {
    return Http.put(...args);
  }

  delete(...args) {
    return Http.delete(...args);
  }

  upload(...args) {
    return Http.upload(...args);
  }
};
